import { useMemo } from 'react';
import { StyleSheet, type ImageStyle, type TextStyle, type ViewStyle } from 'react-native';
import { useTheme } from '../context/ThemeContext';
import { applyCardEdgeToStyles } from './cardEdge';
import type { AppColors } from './palettes';

type NamedStyles<T> = { [P in keyof T]: ViewStyle | TextStyle | ImageStyle };

/** Rebuild StyleSheet when theme colors change (module-level StyleSheet.create bakes light colors). */
export function createThemedStyles<T extends NamedStyles<T>>(
  factory: (colors: AppColors) => T
): () => T {
  return function useStyles(): T {
    const { colors } = useTheme();
    return useMemo(() => {
      const base = StyleSheet.create(factory(colors));
      return applyCardEdgeToStyles(base, colors);
    }, [colors]);
  };
}
